// Shared job status configuration for all widgets and views
export const STATUS_CFG = {
  not_started: { color: "#78909c", label: "Not Started" },
  pending:     { color: "#ff9800", label: "Pending" },
  in_progress: { color: "#2196f3", label: "In Progress" },
  review:      { color: "#9c27b0", label: "Review" },
  approved:    { color: "#00bcd4", label: "Approved" },
  filed:       { color: "#4caf50", label: "Filed" },
  invoiced:    { color: "#4caf50", label: "Invoiced" },
  cancelled:   { color: "#9e9e9e", label: "Cancelled" },
  overdue:     { color: "#f44336", label: "Overdue" },
};

